export enum STEP_IDS {
  SELECT_ASSET_CLASSES = 'SELECT_ASSET_CLASSES',
  NAME_CUSTOM_ASSET_CLASSES = 'NAME_CUSTOM_ASSET_CLASSES',
  SET_RETURNS_AND_VOLATILITIES = 'SET_RETURNS_AND_VOLATILITIES',
  IMPORT_CORRELATION_MATRIX = 'IMPORT_CORRELATION_MATRIX',
}
